import React, { Component } from 'react';
import { browserHistory } from 'react-router';

class LocalStorageCheck extends Component {
    componentWillMount() {
        if( ( !localStorage.token || !localStorage.permissions || parseInt( localStorage.unauthorized, 10 ) === 1 ) ) {
            browserHistory.push( '/login' );
        }
    };

    render() {
        return this.props.children;
    };
}

export default LocalStorageCheck;



// WEBPACK FOOTER //
// src/client/components/common/authentication/LocalStorageCheck.js